<template></template>

<script>
export default {
    props: {
        data: Object,

        type: String,

        diet: {
            type: String,
            default: null
        }
    },

    mounted() {
        document.addEventListener('DOMContentLoaded', (event) => {
            window.dataLayer = window.dataLayer || [];

            if (this.type === 'begin_checkout') {
                let item = {
                    item_name: this.data.product.product_name,
                    item_id: this.data.product.prod_id,
                    price: this.data.price,
                    quantity: 1
                };

                if (this.data.product.diet) {
                    item.item_category = toStringhis.data.product.diet;
                }

                window.dataLayer.push({
                    event: 'begin_checkout',
                    ecommerce: {
                        items: [item]
                    }
                });
            }

            if (this.type === 'purchase') {
                let item = {
                    item_name: this.data.product_name,
                    item_id: this.data.product_id,
                    price: this.data.total_amount,
                    quantity: 1
                };

                if (this.diet) {
                    item.item_category = this.diet;
                }

                window.dataLayer.push({
                    event: 'purchase',
                    ecommerce: {
                        currency: 'SEK',
                        value: this.data.total_amount,
                        tax: (this.data.total_amount * 100 * 0.2) / 100,
                        shipping: 0,
                        transaction_id: this.data.id,
                        items: [item]
                    }
                });
            }
        });
    }
};
</script>
